import React from 'react';
import { MdErrorOutline } from 'react-icons/md';

interface ChartErrorProps {
  error: string;
  onRetry?: () => void;
  title?: string;
  retryText?: string;
  containerClassName?: string;
  height?: string | number;
  iconColor?: string;
  buttonColor?: string;
}

const ChartError: React.FC<ChartErrorProps> = ({
  error,
  onRetry,
  title = "Unable to Load Chart",
  retryText = "Try Again",
  containerClassName = "",
  height = "350px",
  iconColor = "text-red-400",
  buttonColor = "bg-blue-600 hover:bg-blue-700 focus:ring-blue-500"
}) => {
  const heightClass = typeof height === 'number' ? `h-[${height}px]` : `h-[${height}]`;

  return (
    <div className={`flex flex-col items-center justify-center ${heightClass} text-center px-4 ${containerClassName}`}>
      <div className="mb-4">
        <MdErrorOutline className={`w-16 h-16 ${iconColor} mx-auto mb-4`} />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-500 mb-4 max-w-sm">
          {error}
        </p>
        {onRetry && (
          <button
            onClick={onRetry}
            className={`px-4 py-2 ${buttonColor} text-white text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors`}
          >
            {retryText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ChartError;